import { ExamCenterProctorDetailsProvider } from '@exam-center/exam-center-proctor-details';
import { APP_PERMISSIONS } from '@exam-center/permission';
import { useParams } from '@exam-center/router';
import { PermissionGuard } from '@shared/permissions';

export default function ExamCenterProctorDetailsLayout() {
  const { examCenterCode, proctorId } = useParams(
    '/:examCenterCode/exam-proctors/proctors/:proctorId',
  );
  return (
    <PermissionGuard requiredPermission={[APP_PERMISSIONS.PROCTOR_MANAGEMENT.PROCTOR.VIEW]}>
      <ExamCenterProctorDetailsProvider examCenterCode={examCenterCode} proctorId={proctorId} />
    </PermissionGuard>
  );
}
